// Centralized providers for standalone bootstrap
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { inject, provideAppInitializer } from "@angular/core";
import { LoginService } from "@app/core/services";
import { reducers as coreReducers } from "@core/store";
import { effects as coreEffects } from "@core/store/effects";
import { CustomSerializer } from "@core/store/reducers/custom-serializer";
import { effects as myAccountEffects } from "@my-account/store/effects";
import { reducers as myAccountReducers } from "@my-account/store/reducers";
import { effects as usersEffects } from "@users/store/effects";
import { reducers as usersReducers } from "@users/store/reducers";
import { provideEffects } from "@ngrx/effects";
import { provideRouterStore, RouterStateSerializer } from "@ngrx/router-store";
import { provideState, provideStore } from "@ngrx/store";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { effects as organizationsEffects } from "@organizations/store/effects";
import { reducers as organizationsReducers } from "@organizations/store/reducers";

export const providers = [
  provideHttpClient(withInterceptorsFromDi()),
  provideStore(),
  provideState("core", coreReducers),
  provideEffects(coreEffects),
  provideState("my-account", myAccountReducers),
  provideEffects(myAccountEffects),
  provideState("my-organizations", organizationsReducers),
  provideEffects(organizationsEffects),
  provideState("users", usersReducers),
  provideEffects(usersEffects),
  provideRouterStore(),
  { provide: RouterStateSerializer, useClass: CustomSerializer },
  provideTranslateService({
    fallbackLang: "en",
    loader: provideTranslateHttpLoader({ prefix: "./assets/i18n/", suffix: ".json" })
  }),
  provideAppInitializer(() => {
    const loginService = inject(LoginService);
    return loginService.setup();
  })
];
